var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Change Password")]),_c('br'),_c('el-input',{attrs:{"placeholder":"new password"},model:{value:(_vm.newpass),callback:function ($$v) {_vm.newpass=$$v},expression:"newpass"}}),_c('br'),_c('el-button',{on:{"click":_vm.change}},[_vm._v("Change")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }